import { render, staticRenderFns } from "./BankAccountInfo.vue?vue&type=template&id=0ccc4c8e&scoped=true"
import script from "./BankAccountInfo.vue?vue&type=script&lang=js"
export * from "./BankAccountInfo.vue?vue&type=script&lang=js"
import style0 from "./BankAccountInfo.vue?vue&type=style&index=0&id=0ccc4c8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccc4c8e",
  null
  
)

export default component.exports